import { render, staticRenderFns } from "./AddOrderGeneralModal.vue?vue&type=template&id=0c705d17&scoped=true&"
import script from "./AddOrderGeneralModal.vue?vue&type=script&lang=js&"
export * from "./AddOrderGeneralModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c705d17",
  null
  
)

export default component.exports